// extracted by mini-css-extract-plugin
export default {"container":"DIDCallLogs_container__aqs8g","text":"DIDCallLogs_text__w3e5N","paginationContainer":"DIDCallLogs_paginationContainer__1eK3f"};